var module = angular.module('main.resellerorder');

module.component('resellerorderBreadcrumbs',{
    templateUrl: 'main/resellerorder/genericcomponents/resellerorderbreadcrumbs.cmp.tpl.html',
    bindings: {
        currentPage: '<'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($state, $translate) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    //Properties

    //Methods
    vm.transitionToState = transitionToState;

    function onInit() {
    }
    function onChanges() {
    }

    function transitionToState(state) {
        $state.go(state);
    }
}
